export const globalStyles = `
  html,
  body,
  #customer-registration {
    height: 100vh;
  }
`;
